var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: "Cadastrar template de email",
      icon: "mdi-card-account-mail-outline",
      show: _vm.dialog,
      maxWidth: "65%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            dense: "",
                            error: _vm.errors.length > 0,
                            "error-messages": _vm.errors.subject,
                            label: "Assunto",
                          },
                          model: {
                            value: _vm.model.subject,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "subject", $$v)
                            },
                            expression: "model.subject",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("span", [_vm._v("Corpo")]),
                        _c("vue-editor", {
                          attrs: { editorToolbar: _vm.customToolbar },
                          model: {
                            value: _vm.model.body,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "body", $$v)
                            },
                            expression: "model.body",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("span", [_vm._v("Rodapé")]),
                        _c("vue-editor", {
                          attrs: { editorToolbar: _vm.customToolbar },
                          model: {
                            value: _vm.model.footer,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "footer", $$v)
                            },
                            expression: "model.footer",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }